import { render } from "./DeleteProfile.vue?vue&type=template&id=346fa346&scoped=true"
import script from "./DeleteProfile.vue?vue&type=script&lang=js"
export * from "./DeleteProfile.vue?vue&type=script&lang=js"

import "./DeleteProfile.vue?vue&type=style&index=0&id=346fa346&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346fa346"]])

export default __exports__